// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

import { Theme } from '@mui/material';
import { ThemeMode } from 'types/config';

export default function Table(theme: Theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: theme.palette.mode === ThemeMode.LIGHT ? theme.palette.secondary.colorNeutrals?.neutrals20 : theme.palette.secondary[100]
        }
      }
    }
  };
}
